<template>
  <div class="equipOpenTime" ref="equipOpenTime">
    <div class="tab" :class="{'typeBlue': styleType == 'typeBlue'}">
      <a
        class="home_tab"
        v-for="(item, i) in selectArr"
        :key="i"
        :class="{ home_tab_actived: selectIndex == i + 1 }"
        @click.stop="handleItem(i + 1)"
      >{{ item.name }}</a>
      <el-select v-model="optionIndex" filterable placeholder="请选择" @change="change()">
        <el-option v-for="(item, i) in options" :key="i" :label="item.name" :value="item.num"></el-option>
      </el-select>
    </div>
    <div class="innerBox">
      <div class="charts">
        <!--div class="chart1" v-if="lineType">
          <div class="chart_line" ref="chart1"></div>
        </div-->
        <div class="chart2">
          <div class="chart_column" ref="chart2"></div>
        </div>
      </div>
      <div class="allCount">
        <div class="bg absolute_center"></div>
        <div class="circle"></div>
        <div class="today_all_count absolute_center">
          <div class="div1" v-text="getStaticType()"></div>
          <div class="div2 number">{{ allCount }}</div>
          <div class="div3">小时</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getOptBar from './chartBar.js'
import { unwarp } from '@/utils/tools.js'
import { setPageActive } from '@/utils/platformmonitor.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  props: ['matrix', 'x', 'y'],
  data() {
    //这里存放数据
    return {
      pageInfo: 'equipOpenTime.vue',
      computedName: '设备运行时长组件',
      styleType: '',
      allCount: 9,
      unit: 2,
      customerId: this.$store.state.customerId,
      chart2: null,
      selectIndex: 0,
      selectArr: [{ name: '日' }, { name: '周' }, { name: '月' }, { name: '年' }],
      optionIndex: 1,
      options: [
        { name: '生产设备', num: 1 },
        { name: '治理设备', num: 2 }
      ],
      changeTimer: null
    }
  },
  //计算属性 类似于data概念
  computed: {
    getStaticType() {
      return function () {
        let typeName = ''
        if (this.selectIndex === 1) {
          typeName = '日累计'
        } else if (this.selectIndex === 2) {
          typeName = '周累计'
        } else if (this.selectIndex === 3) {
          typeName = '月累计'
        } else if (this.selectIndex === 4) {
          typeName = '年累计'
        }
        return typeName
      }
    },
    curStyleTypeVal() {
      return this.$store.state.styleType
    }
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
        this.typeChange()
      },
      deep: true
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    let w = $(that.$refs.equipOpenTime).outerWidth()
    let h = $(that.$refs.equipOpenTime).outerHeight()
    that.$emit('componentInit', {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y
    })
    this.handleItem(1)
    this.typeChange()
  },
  //方法集合
  methods: {
    handleItem(index) {
      if (this.changeTimer) {
        clearTimeout(this.changeTimer)
        this.changeTimer = null
      }
      this.selectIndex = index
      this.getData()
    },
    convertListByHour2(data) {
      if (!data.length) return { time: [], value: [] }
      let arr = data.slice(-9)
      let returnData = { time: [], value: [] }
      arr.forEach(item => {
        item.time = item.time.split(' ')[1]
        returnData.time.push(item.time)
        returnData.value.push(item.value)
      })
      return returnData
    },
    async getData() {
      let that = this
      let deviceRunTimeUrl = CONFIG.requestName + this.$apiOpt.deviceRunTime
      let data = await that.$apiUtils.get(deviceRunTimeUrl, {
        customerId: that.customerId,
        type: that.optionIndex,
        timeType: that.selectIndex
      })
      let sumTime = data?.sumTime
      this.allCount = parseInt(sumTime)
      let runTimeList = data?.list || []
      if (that.selectIndex === 1) {
        let result = that.convertListByHour2(runTimeList)
        console.log('121', result)
        // let result = runTimeList;
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose()
        }
        that.chart2 = echarts.init(that.$refs.chart2)
        unwarp(that.chart2).setOption(getOptBar(result))
      } else if (that.selectIndex === 2) {
        let result = that.convertListByWeek(runTimeList)
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose()
        }
        that.chart2 = echarts.init(that.$refs.chart2)
        unwarp(that.chart2).setOption(getOptBar(result))
      } else if (that.selectIndex === 3) {
        let result = that.convertListByMonth(runTimeList)
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose()
        }
        that.chart2 = echarts.init(that.$refs.chart2)
        unwarp(that.chart2).setOption(getOptBar(result))
      } else if (that.selectIndex === 4) {
        let result = that.convertListByYear(runTimeList)
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose()
        }
        that.chart2 = echarts.init(that.$refs.chart2)
        unwarp(that.chart2).setOption(getOptBar(result))
      }
      this.changeTimer = setTimeout(() => this.autoChange(), 8 * 1000)
      //alert(2222222222222222);
    },
    convertListByHour(list) {
      let result = {
        '0:00': 0,
        '4:00': 0,
        '8:00': 0,
        '12:00': 0,
        '16:00': 0,
        '20:00': 0
      }
      let resultObj = {}
      list.forEach(element => {
        let tmpTime = element.time
        if (tmpTime) {
          let tmpHour = new Date(tmpTime.replace(/-0/g, '/').replace(/-/g, '/')).getHours()
          if (tmpHour < 4) {
            result['0:00'] += parseFloat(element.value)
          } else if (tmpHour < 8) {
            result['4:00'] += parseFloat(element.value)
          } else if (tmpHour < 12) {
            result['8:00'] += parseFloat(element.value)
          } else if (tmpHour < 16) {
            result['12:00'] += parseFloat(element.value)
          } else if (tmpHour < 20) {
            result['16:00'] += parseFloat(element.value)
          } else {
            result['20:00'] += parseFloat(element.value)
          }
        }
      })
      resultObj.time = []
      resultObj.value = []
      for (let i in result) {
        resultObj.time.push(i)
        resultObj.value.push(result[i].toFixed(2))
      }
      return resultObj
    },
    convertListByWeek(list) {
      /*let weekFirstDay = new Date(
        new Date() - (new Date().getDay() - 1) * 86400000
      ).getTime();*/
      let resultObj = {}
      resultObj.time = []
      resultObj.value = []
      let obj = {}
      list.forEach(item => {
        let key = new Date(item.time.replace(/-0/g, '/').replace(/-/g, '/'))
        let time = key.getMonth() + 1 + '-' + key.getDate()
        let value = item.value && item.value.toFixed ? item.value.toFixed(2) : item.value
        if (obj[time]) {
          obj[time] += Number(value)
        } else {
          obj[time] = Number(value)
        }
        // resultObj.time.push(key.getMonth() + 1 + '-' + key.getDate())
        // obj[key.getMonth() + 1 + '-' + key.getDate()] =
        // resultObj.value.push(item.value && item.value.toFixed ? item.value.toFixed(2) : item.value)
      })

      for (let key in obj) {
        resultObj.time.push(key)
        resultObj.value.push(obj[key])
      }
      return resultObj
    },
    convertListByMonth(list) {
      let year = new Date().getFullYear()
      let month = new Date().getMonth() + 1
      let week1 = month + '-1'
      let week2 = month + '-8'
      let week3 = month + '-15'
      let week4 = month + '-22'
      let result = {}
      result[week1] = 0
      result[week2] = 0
      result[week3] = 0
      result[week4] = 0
      let resultObj = {}
      list.forEach(element => {
        let tmpTime = element.time
        if (tmpTime) {
          let tempTs = new Date(tmpTime.replace(/-0/g, '/').replace(/-/g, '/')).getTime()
          if (tempTs < new Date((year + '-' + week2).replace(/-/g, '/')).getTime()) {
            result[week1] += parseFloat(element.value)
          } else if (tempTs < new Date((year + '-' + week3).replace(/-/g, '/')).getTime()) {
            result[week2] += parseFloat(element.value)
          } else if (tempTs < new Date((year + '-' + week4).replace(/-/g, '/')).getTime()) {
            result[week3] += parseFloat(element.value)
          } else {
            result[week4] += parseFloat(element.value)
          }
        }
      })
      resultObj.time = []
      resultObj.value = []
      for (let i in result) {
        resultObj.time.push(i)
        resultObj.value.push(result[i] && result[i].toFixed ? result[i].toFixed(2) : result[i])
      }
      console.log('resultObj1', resultObj)
      return resultObj
    },
    convertListByYear(list) {
      let year = new Date().getFullYear()
      let month = new Date().getMonth() + 1
      let week1 = '一季度'
      let week2 = '二季度'
      let week3 = '三季度'
      let week4 = '四季度'
      let week1_ = '4-1'
      let week2_ = '7-1'
      let week3_ = '10-1'
      let result = {}
      result[week1] = 0
      result[week2] = 0
      result[week3] = 0
      result[week4] = 0
      let resultObj = {}
      list.forEach(element => {
        let tmpTime = element.time
        if (tmpTime) {
          let tempTs = new Date(tmpTime.replace(/-0/g, '/').replace(/-/g, '/')).getTime()
          if (tempTs < new Date((year + '-' + week1_).replace(/-/g, '/')).getTime()) {
            result[week1] += parseFloat(element.value)
          } else if (tempTs < new Date((year + '-' + week2_).replace(/-/g, '/')).getTime()) {
            result[week2] += parseFloat(element.value)
          } else if (tempTs < new Date((year + '-' + week3_).replace(/-/g, '/')).getTime()) {
            result[week3] += parseFloat(element.value)
          } else {
            result[week4] += parseFloat(element.value)
          }
        }
      })
      resultObj.time = []
      resultObj.value = []
      for (let i in result) {
        resultObj.time.push(i)
        resultObj.value.push(result[i] && result[i].toFixed ? result[i].toFixed(2) : result[i])
      }
      return resultObj
    },
    change() {
      setPageActive("设备运行时长统计-2*1","open",1)
      this.getData()
    },
    typeChange() {
      if (this.styleType == 'typeGreen') {
        this.$nextTick(() => {
          $('.equipOpenTime .tab').css('margin-top', '20px')
          $('.equipOpenTime .innerBox').css('height', '170px')
        })
      } else if (this.styleType == 'typeDark') {
        this.$nextTick(() => {
          $('.equipOpenTime .tab').css('margin-top', 'initial')
          $('.equipOpenTime .innerBox').css('height', '180px')
        })
      } else if (this.styleType == 'typeStrong') {
        this.$nextTick(() => {
          $('.equipOpenTime .tab').css('margin-top', '20px')
          $('.equipOpenTime .innerBox').css('height', '170px')
        })
      }
    },
    autoChange() {
      if (this.selectIndex > 3) {
        this.selectIndex = 0
      }
      this.selectIndex += 1
      this.handleItem(this.selectIndex)
    }
  },
  unmounted() {
    if (this.chart2) {
      this.chart2.dispose()
      this.chart2 = null
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.equipOpenTime {
  width: 600px;
  height: 250px;
  .tab {
    justify-content: flex-end;
    z-index: 1;
    display: flex;
    .el-select {
      width: 125px;
      height: 26px;
    }
  }
  .typeBlue {
    padding-top: 10px;
    .home_tab {
      width: 56px;
      height: 26px;
      background: url('./img/tab_default.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
    .home_tab_actived {
      width: 56px;
      height: 26px;
      background: url('./img/tab_active.png') no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
    .el-select {
      width: 125px;
      height: 30px;
    }
  }
  .innerBox {
    @include bg-box(560px, 180px, 'imgBg.png');
    display: flex;
    margin-top: 6px;
    padding-left: 10px;

    .charts {
      width: 340px;
      height: 100%;
      margin-right: 10px;
      // padding: 20px 0px 0px;
      .chart1 {
        width: 100%;
        height: 100%;
        .chart_line {
          width: 100%;
          height: 100%;
        }
      }
      .chart2 {
        width: 100%;
        height: 100%;
        .chart_column {
          width: 100%;
          height: 100%;
        }
      }
    }
    .allCount {
      width: 200px;
      height: 100%;
      position: relative;
      .bg {
        position: absolute;
        @include bg-box(90px, 92px, 'flowerBg.png');
      }
      .circle {
        @include bg-box(170px, 170px, 'circle.png');
        top: 7px;
        left: 18px;
        position: absolute;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-180deg);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
      .today_all_count {
        width: 100px;
        height: 85px;
        text-align: center;
        padding-top: 5px;
        .div1 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }
        .div2 {
          width: 100%;
          height: 28px;
          font-size: 28px;
          color: #99f5ff;
          line-height: 28px;
        }
        .div3 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
        }
      }
    }
  }
}
</style>
<style>
.equipOpenTime .el-select {
  margin-left: 5px;
  height: 26px;
}
.equipOpenTime .el-select .select-trigger {
  height: 26px !important;
}
.equipOpenTime .el-select .select-trigger .el-input {
  height: 26px;
}
.equipOpenTime .el-select .select-trigger .el-input .el-input__inner {
  height: 26px !important;
}
.equipOpenTime .el-select .select-trigger .el-input .el-input__suffix-inner {
  display: flex;
}
.equipOpenTime .el-select .select-trigger .el-input .el-input__suffix-inner .el-icon-arrow-up {
  line-height: 26px;
}

.equipOpenTime .home_tab {
  margin-left: 10px;
}

.equipOpenTime .typeBlue .el-select {
  margin-left: 5px;
  height: 26px;
}
.equipOpenTime .typeBlue.el-select .select-trigger {
  height: 26px !important;
}
.equipOpenTime .typeBlue .el-select .select-trigger .el-input {
  height: 26px;
}
.equipOpenTime .typeBlue .el-select .select-trigger .el-input .el-input__inner {
  height: 26px !important;
  border: none;
  box-shadow: none;
  background: url('./img/select_bg.png') no-repeat;
  background-size: 100% 100%;
  border-radius: 0;
}

.equipOpenTime .typeBlue .el-input__suffix {
  margin-top: 8px;
}
</style>
